@if (site && site.template) {
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>
        {{ 'PAGES.OVERVIEW.MANAGE_TEMPLATE_CARD.TITLE' | translate }}
      </mat-card-title>
    </mat-card-header>
    <mat-card-content class="card-regular">
      <p>{{ this.templateSubtitle | translate }}</p>
    </mat-card-content>
    <mat-card-actions>
      <button mat-raised-button color="accent" class="short-button" [disabled]="disableButton" (click)="showDialog()">
        @if (!disableButton) {
          <span>{{ this.templateCTA | translate }}</span>
        }
        @if (disableButton) {
          <mat-spinner class="info-spinner-small" color="accent" [diameter]="25" [strokeWidth]="4"></mat-spinner>
        }
      </button>
      @if (toggleVisible) {
        <div class="toggle-container">
          <span>{{ distributeTemplateLabel }}</span>
          <mat-slide-toggle [checked]="isTemplateDistributed" (change)="onTemplateDistributionToggle()" color="primary">
          </mat-slide-toggle>
        </div>
      }
    </mat-card-actions>
  </mat-card>
}
